// extracted by mini-css-extract-plugin
export default {"login":"login_ZCkC9","loginLeft":"loginLeft_hmu5_","footerRecordNo":"footerRecordNo_jr0j6","resettingPassword":"resettingPassword_utlzI"};